import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  BreadcrumbsAccessReviewCustodian,
  BreadcrumbsAccessReviewDetail,
  BreadcrumbsAccessReviewHistory,
  BreadcrumbsAccessReviews,
  BreadcrumbsAdvisoryDetail,
  BreadcrumbsAdvisoryTemplateDetail,
  BreadcrumbsBaselineDataAccessPermission,
  BreadcrumbsBaselineMembership,
  BreadcrumbsBootstrapActionDetails,
  BreadcrumbsBootstrapActionFormNew,
  BreadcrumbsBootstrapActionFormUpdate,
  BreadcrumbsBrowseCatalogs,
  BreadcrumbsBrowseDatabases,
  BreadcrumbsBrowseDatasets,
  BreadcrumbsBrowseWorkspaces,
  BreadcrumbsBusinessGlossaries,
  BreadcrumbsCatalogDetails,
  BreadcrumbsClassification,
  BreadcrumbsConsumedPermissions,
  BreadcrumbsContractDetail,
  BreadcrumbsCreateAdvisory,
  BreadcrumbsCreateAdvisoryFromAdvisory,
  BreadcrumbsCreateAdvisoryFromTemplate,
  BreadcrumbsCreateBusinessGlossary,
  BreadcrumbsCreateFgaPolicy,
  BreadcrumbsCreateGovernanceTag,
  BreadcrumbsCreateLakeFormationPermission,
  BreadcrumbsCreateMetadataForm,
  BreadcrumbsCreateNewGroup,
  BreadcrumbsCreateNotifications,
  BreadcrumbsCreateNotificationTemplate,
  BreadcrumbsCreateReport,
  BreadcrumbsCreateTag,
  BreadcrumbsCreateTemplate,
  BreadcrumbsCreateWorkspace,
  BreadcrumbsDatabaseDetails,
  BreadcrumbsDatasetDetails,
  BreadcrumbsDataZoneManage,
  BreadcrumbsDataZoneOnboard,
  BreadcrumbsEditAdvisory,
  BreadcrumbsEditAdvisoryTemplate,
  BreadcrumbsEditBusinessGlossary,
  BreadcrumbsEditFgaPolicy,
  BreadcrumbsEditGovernanceTag,
  BreadcrumbsEditMetadataForm,
  BreadcrumbsEditTag,
  BreadcrumbsEditTemplate,
  BreadcrumbsEventSubscriptionDetails,
  BreadcrumbsEventSubscriptions,
  BreadcrumbsFgaPolicies,
  BreadcrumbsGovernanceTags,
  BreadcrumbsListAdvisories,
  BreadcrumbsListAdvisoryTemplates,
  BreadcrumbsListReports,
  BreadcrumbsListRequests,
  BreadcrumbsMetadataForms,
  BreadcrumbsMetricCollectionDefinition,
  BreadcrumbsMetricCollectionMonthlyView,
  BreadcrumbsMetricCollectionQuarterlyView,
  BreadcrumbsMetricCollectionWeeklyView,
  BreadcrumbsMetricCollectionYearlyView,
  BreadcrumbsMetricsCatalogDefinition,
  BreadcrumbsMonitoringDataset,
  BreadcrumbsMyBaselining,
  BreadcrumbsMyBootstrapActions,
  BreadcrumbsMyDatasets,
  BreadcrumbsMyDatasetsDetails,
  BreadcrumbsMyGroup,
  BreadcrumbsMyGroups,
  BreadcrumbsMyNotifications,
  BreadcrumbsMyResourceGroups,
  BreadcrumbsNotificationBatchDetail,
  BreadcrumbsNotificationConfiguration,
  BreadcrumbsNotificationDetail,
  BreadcrumbsNotificationTemplateDetail,
  BreadcrumbsNotificationTemplates,
  BreadcrumbsPermissionDetail,
  BreadcrumbsPermissionRequestDetails,
  BreadcrumbsPublish,
  BreadcrumbsPublishedTables,
  BreadcrumbsPublishRegisterTable,
  BreadcrumbsRegisterContract,
  BreadcrumbsReportDetails,
  BreadcrumbsReportingTableDefinition,
  BreadcrumbsRequestContextDetails,
  BreadcrumbsResourceDetails,
  BreadcrumbsResourceGroupDetails,
  BreadcrumbsResourceGroupFormNew,
  BreadcrumbsResourceGroupFormUpdate,
  BreadcrumbsSchemaDetails,
  BreadcrumbsSearchData,
  BreadcrumbsSendAdvisoryNotification,
  BreadcrumbsTags,
  BreadcrumbsTemplateDetails,
  BreadcrumbsTemplateNew,
  BreadcrumbsTemplates,
  BreadcrumbsTemplateUpdate,
  BreadcrumbsTemplateView,
  BreadcrumbsUpdateContract,
  BreadcrumbsUpdateNotificationTemplate,
  BreadcrumbsUpdateWorkspace,
  BreadcrumbsViewBusinessGlossary,
  BreadcrumbsViewFgaPolicy,
  BreadcrumbsViewGovernanceTag,
  BreadcrumbsViewMetadataForm,
  BreadcrumbsViewMetricCollectionsCatalog,
  BreadcrumbsViewMetricsCatalog,
  BreadcrumbsViewReportingTablesCatalog,
  BreadcrumbsWorkspaceDetail,
  BreadCrumbsWorkspaceTagAccess,
  BreadcrumbsWSDatasetDetails,
  BreadcrumbsWSDetails,
  BreadcrumbsWSGlueRegister,
  BreadcrumbsWSRedshiftQuery,
  BreadcrumbsWSRedshiftRegister,
  BreadcrumbsWSResourceLinks,
  BreadcrumbsWSTagDetails,
  BreadcrumbsWSTagRegister,
  BreadcrumbsSmusResources,
  BreadcrumbsSsoGroupDetails,
} from '../commons/breadcrumbs';
import { Page } from 'src/routes/Paths';

export const Breadcrumbs = (props) => (
  <Switch>
    <Route
      path={Page.METRICS_CATALOG}
      exact
      component={(route_props) => <BreadcrumbsViewMetricsCatalog {...route_props} {...props} />}
    />
    <Route
      path={Page.METRIC_DEFINITION}
      exact
      component={(route_props) => <BreadcrumbsMetricsCatalogDefinition {...route_props} {...props} />}
    />
    <Route
      path={Page.METRIC_COLLECTIONS_CATALOG}
      exact
      component={(route_props) => <BreadcrumbsViewMetricCollectionsCatalog {...route_props} {...props} />}
    />
    <Route
      path={Page.METRIC_COLLECTIONS_DEFINITION}
      exact
      component={(route_props) => <BreadcrumbsMetricCollectionDefinition {...route_props} {...props} />}
    />
    <Route
      path={Page.METRIC_COLLECTION_WEEKLY_VIEW}
      exact
      component={(route_props) => <BreadcrumbsMetricCollectionWeeklyView {...route_props} {...props} />}
    />
    <Route
      path={Page.METRIC_COLLECTION_MONTHLY_VIEW}
      exact
      component={(route_props) => <BreadcrumbsMetricCollectionMonthlyView {...route_props} {...props} />}
    />
    <Route
      path={Page.METRIC_COLLECTION_QUARTERLY_VIEW}
      exact
      component={(route_props) => <BreadcrumbsMetricCollectionQuarterlyView {...route_props} {...props} />}
    />
    <Route
      path={Page.METRIC_COLLECTION_YEARLY_VIEW}
      exact
      component={(route_props) => <BreadcrumbsMetricCollectionYearlyView {...route_props} {...props} />}
    />
    <Route
      path={Page.REPORTING_TABLE_CATALOG}
      exact
      component={(route_props) => <BreadcrumbsViewReportingTablesCatalog {...route_props} {...props} />}
    />
    <Route
      path={Page.REPORTING_TABLE_DEFINITION}
      exact
      component={(route_props) => <BreadcrumbsReportingTableDefinition {...route_props} {...props} />}
    />
    <Route
      path={Page.BROWSE_CATALOGS}
      exact
      render={(route_props) => <BreadcrumbsBrowseCatalogs {...route_props} {...props} />}
    />
    <Route
      path={[
        Page.S3_TABLE_CATALOG_DETAILS,
        Page.CATALOG_DETAILS,
        Page.REDSHIFT_CATALOG_DETAILS,
        Page.REDSHIFT_SERVERLESS_CATALOG_DETAILS,
        Page.DEPRECATED_WKS_CATALOG_DETAILS,
      ]}
      exact
      render={(route_props) => <BreadcrumbsCatalogDetails {...route_props} {...props} />}
    />

    <Route
      path={Page.BROWSE_DATABASES}
      exact
      render={(route_props) => <BreadcrumbsBrowseDatabases {...route_props} {...props} />}
    />

    <Route
      path={Page.BROWSE_DATASETS}
      exact
      render={(route_props) => <BreadcrumbsBrowseDatasets {...route_props} {...props} />}
    />
    <Route
      path={Page.DATASET_DETAILS}
      exact
      render={(route_props) => <BreadcrumbsDatasetDetails {...route_props} {...props} />}
    />

    <Route
      path={[Page.LF_PERMISSION_DETAIL, Page.LF_PERMISSION_DETAIL_SIMPLIFIED]}
      exact
      render={(route_props) => <BreadcrumbsPermissionDetail {...route_props} {...props} />}
    />

    <Route path={Page.PUBLISH} exact render={(route_props) => <BreadcrumbsPublish {...route_props} {...props} />} />

    <Route
      path={Page.PUBLISHER_TABLES}
      exact
      render={(route_props) => <BreadcrumbsPublishedTables {...route_props} {...props} />}
    />
    <Route
      path={Page.CREATE_PUBLISHER_TABLE}
      exact
      render={(route_props) => <BreadcrumbsPublishRegisterTable {...route_props} {...props} />}
    />

    <Route path={Page.REQUESTS} exact component={BreadcrumbsListRequests} />
    <Route path={Page.BASELINING} exact component={BreadcrumbsMyBaselining} />
    <Route path={Page.BASELINE_DATA_ACCESS_PERMISSION} exact component={BreadcrumbsBaselineDataAccessPermission} />

    <Route
      path={[Page.BASELINE_OWNER_WITH_ACCOUNT_ID, Page.BASELINE_OWNER]}
      exact
      component={BreadcrumbsBaselineMembership}
    />

    <Route path={Page.REVIEWS} exact component={BreadcrumbsAccessReviews} />
    <Route path={Page.REVIEW_DETAILS} exact component={BreadcrumbsAccessReviewDetail} />
    <Route path={Page.REVIEW_CUSTODIAN} exact component={BreadcrumbsAccessReviewCustodian} />
    <Route path={Page.REVIEW_HISTORY} exact component={BreadcrumbsAccessReviewHistory} />

    <Route path={Page.LIST_ADVISORIES} exact component={BreadcrumbsListAdvisories} />
    <Route path={Page.CREATE_ADVISORY} exact component={BreadcrumbsCreateAdvisory} />
    <Route path={Page.CREATE_ADVISORY_FROM_TEMPLATE} exact component={BreadcrumbsCreateAdvisoryFromTemplate} />
    <Route path={Page.CREATE_ADVISORY_FROM_ADVISORY} exact component={BreadcrumbsCreateAdvisoryFromAdvisory} />
    <Route path={Page.UPDATE_ADVISORY} exact component={BreadcrumbsEditAdvisory} />
    <Route path={Page.ADVISORY_SEND_NOTIFICATION} exact component={BreadcrumbsSendAdvisoryNotification} />
    <Route path={Page.LIST_ADVISORY_TEMPLATES} exact component={BreadcrumbsListAdvisoryTemplates} />
    <Route path={Page.UPDATE_ADVISORY_TEMPLATE} exact component={BreadcrumbsEditAdvisoryTemplate} />
    <Route path={Page.ADVISORY_TEMPLATE_DETAIL} exact component={BreadcrumbsAdvisoryTemplateDetail} />
    <Route path={Page.ADVISORY_DETAIL} exact component={BreadcrumbsAdvisoryDetail} />

    <Route
      path={Page.CREATE_LAKE_FORMATION_PERMISSIONS}
      exact
      render={(route_props) => <BreadcrumbsCreateLakeFormationPermission {...route_props} {...props} />}
    />

    <Route
      path={Page.REDSHIFT_PERMISSION_DETAIL}
      exact
      render={(route_props) => <BreadcrumbsPermissionDetail {...route_props} {...props} />}
    />

    <Route
      path={Page.PUBLISHED_PERMISSION_DETAIL}
      exact
      render={(route_props) => <BreadcrumbsPermissionDetail {...route_props} {...props} />}
    />

    <Route
      path={[Page.REQUEST_DETAILS, Page.WORKSPACE_MY_REQUEST_DETAILS]}
      exact
      render={(route_props) => <BreadcrumbsPermissionRequestDetails {...route_props} {...props} />}
    />

    <Route
      path={Page.MY_DATASETS}
      exact
      render={(route_props) => <BreadcrumbsMyDatasets {...route_props} {...props} />}
    />
    <Route
      path={Page.DATASETSHARE_DETAILS}
      exact
      render={(route_props) => <BreadcrumbsMyDatasetsDetails {...route_props} {...props} />}
    />

    <Route
      path={Page.CREATE_NEW_GROUP}
      exact
      render={(route_props) => <BreadcrumbsCreateNewGroup {...route_props} {...props} />}
    />
    <Route path={Page.GROUPS} exact render={(route_props) => <BreadcrumbsMyGroup {...route_props} {...props} />} />
    <Route
      path={Page.GROUP_DETAIL}
      exact
      render={(route_props) => <BreadcrumbsMyGroups {...route_props} {...props} />}
    />

    <Route
      path={Page.WORKSPACEACCESS}
      exact
      render={(route_props) => <BreadCrumbsWorkspaceTagAccess {...route_props} {...props} />}
    />

    <Route path={Page.TAGS} exact render={(route_props) => <BreadcrumbsTags {...route_props} {...props} />} />

    <Route
      path={Page.CREATE_TAGS_TEMPLATE}
      exact
      render={(route_props) => <BreadcrumbsCreateTag {...route_props} {...props} />}
    />

    <Route
      path={Page.EDIT_TAGS_TEMPLATE}
      exact
      render={(route_props) => <BreadcrumbsEditTag {...route_props} {...props} />}
    />

    <Route path={Page.NOTIFICATIONS} exact component={BreadcrumbsMyNotifications} />
    <Route path={Page.CREATE_NOTIFICATION} exact component={BreadcrumbsCreateNotifications} />
    <Route path={Page.NOTIFICATION_DETAILS} exact component={BreadcrumbsNotificationDetail} />
    <Route path={Page.NOTIFICATION_BATCH_DETAILS} exact component={BreadcrumbsNotificationBatchDetail} />

    <Route path={Page.NOTIFICATION_TEMPLATES} exact component={BreadcrumbsNotificationTemplates} />
    <Route path={Page.CREATE_NOTIFICATION_TEMPLATE} exact component={BreadcrumbsCreateNotificationTemplate} />
    <Route path={Page.UPDATE_NOTIFICATION_TEMPLATE} exact component={BreadcrumbsUpdateNotificationTemplate} />
    <Route path={Page.NOTIFICATION_TEMPLATE_DETAILS} exact component={BreadcrumbsNotificationTemplateDetail} />
    <Route path={Page.NOTIFICATION_CONFIGURATION} exact component={BreadcrumbsNotificationConfiguration} />

    <Route
      path={Page.RESOURCEGROUPS}
      exact
      component={(route_props) => <BreadcrumbsMyResourceGroups {...route_props} {...props} />}
    />
    <Route
      path={Page.CREATE_RESOURCEGROUP}
      exact
      component={(route_props) => <BreadcrumbsResourceGroupFormNew {...route_props} {...props} />}
    />
    <Route
      path={Page.UPDATE_RESOURCEGROUP}
      exact
      component={(route_props) => <BreadcrumbsResourceGroupFormUpdate {...route_props} {...props} />}
    />
    <Route
      path={Page.CREATE_RG_TEMPLATE}
      exact
      component={(route_props) => <BreadcrumbsTemplateNew {...route_props} {...props} />}
    />
    <Route
      path={Page.UPDATE_RG_TEMPLATE}
      exact
      component={(route_props) => <BreadcrumbsTemplateUpdate {...route_props} {...props} />}
    />
    <Route
      path={Page.RG_TEMPLATE_DETAILS}
      exact
      component={(route_props) => <BreadcrumbsTemplateDetails {...route_props} {...props} />}
    />
    <Route
      path={Page.RESOURCEGROUP_DETAILS}
      exact
      component={(route_props) => <BreadcrumbsResourceGroupDetails {...route_props} {...props} />}
    />
    <Route
      path={Page.RESOURCE_DETAILS}
      exact
      component={(route_props) => <BreadcrumbsResourceDetails {...route_props} {...props} />}
    />

    <Route
      path={Page.EVENT_SUBSCRIPTIONS}
      exact
      component={(route_props) => <BreadcrumbsEventSubscriptions {...route_props} {...props} />}
    />
    <Route
      path={Page.EVENT_SUBSCRIPTIONS_DETAILS}
      exact
      component={(route_props) => <BreadcrumbsEventSubscriptionDetails {...route_props} {...props} />}
    />

    <Route
      path={Page.BOOTSTRAPACTIONS}
      exact
      component={(route_props) => <BreadcrumbsMyBootstrapActions {...route_props} {...props} />}
    />
    <Route
      path={Page.CREATE_BOOTSTRAPACTION}
      exact
      component={(route_props) => <BreadcrumbsBootstrapActionFormNew {...route_props} {...props} />}
    />
    <Route
      path={Page.UPDATE_BOOTSTRAPACTION}
      exact
      component={(route_props) => <BreadcrumbsBootstrapActionFormUpdate {...route_props} {...props} />}
    />
    <Route
      path={Page.BOOTSTRAPACTION_DETAILS}
      exact
      component={(route_props) => <BreadcrumbsBootstrapActionDetails {...route_props} {...props} />}
    />

    <Route
      path={Page.CREATE_WORKSPACE}
      exact
      component={(route_props) => <BreadcrumbsCreateWorkspace {...route_props} {...props} />}
    />
    <Route
      path={Page.BROWSE_WORKSPACES}
      exact
      component={(route_props) => <BreadcrumbsBrowseWorkspaces {...route_props} {...props} />}
    />
    <Route
      path={Page.CURRENT_WORKSPACE_DETAIL}
      exact
      component={(route_props) => <BreadcrumbsWorkspaceDetail {...route_props} {...props} />}
    />
    <Route
      path={Page.UPDATE_WORKSPACE}
      exact
      component={(route_props) => <BreadcrumbsUpdateWorkspace {...route_props} {...props} />}
    />

    <Route
      path={Page.WORKSPACE_ALL_PERMISSIONS}
      exact
      component={(route_props) => <BreadcrumbsConsumedPermissions {...route_props} {...props} />}
    />

    <Route
      path={Page.WORKSPACES_BROWSE_DATASETS}
      exact
      component={(route_props) => <BreadcrumbsBrowseDatasets {...route_props} {...props} />}
    />

    <Route
      path={Page.SEARCH}
      exact
      component={(route_props) => <BreadcrumbsSearchData {...route_props} {...props} />}
    />
    <Route
      path={Page.WORKSPACES_BROWSE_DATABASES}
      exact
      component={(route_props) => <BreadcrumbsBrowseDatabases {...route_props} {...props} />}
    />

    <Route
      path={Page.WORKSPACES_BROWSE_CATALOGS}
      exact
      component={(route_props) => <BreadcrumbsBrowseCatalogs {...route_props} {...props} />}
    />

    <Route
      path={[
        Page.DATABASE_DETAILS,
        Page.S3_TABLE_DATABASE_DETAILS,
        Page.REDSHIFT_DATABASE_DETAILS,
        Page.REDSHIFT_SERVERLESS_DATABASE_DETAILS,
      ]}
      exact
      component={(route_props) => <BreadcrumbsDatabaseDetails {...route_props} {...props} />}
    />

    <Route
      path={[Page.SCHEMA_DETAILS, Page.SERVERLESS_SCHEMA_DETAILS, Page.DEPRECATED_WKS_SCHEMA_DETAILS]}
      exact
      component={(route_props) => <BreadcrumbsSchemaDetails {...route_props} {...props} />}
    />

    <Route
      path={Page.DATASET_DETAILS}
      exact
      component={(route_props) => <BreadcrumbsWSDatasetDetails {...route_props} {...props} />}
    />

    <Route
      path={Page.WORKSPACE_GLUE_REGISTER}
      exact
      component={(route_props) => <BreadcrumbsWSGlueRegister {...route_props} {...props} />}
    />

    <Route
      path={Page.WORKSPACE_REDSHIFT_REGISTER}
      exact
      component={(route_props) => <BreadcrumbsWSRedshiftRegister {...route_props} {...props} />}
    />

    <Route
      path={Page.WORKSPACE_TAG_REGISTER}
      exact
      component={(route_props) => <BreadcrumbsWSTagRegister {...route_props} {...props} />}
    />
    <Route
      path={Page.TEMPLATES}
      exact
      component={(route_props) => <BreadcrumbsTemplates {...route_props} {...props} />}
    />
    <Route
      path={Page.CREATE_TEMPLATE}
      exact
      component={(route_props) => <BreadcrumbsCreateTemplate {...route_props} {...props} />}
    />
    <Route
      path={Page.TEMPLATE_DETAILS}
      exact
      component={(route_props) => <BreadcrumbsTemplateView {...route_props} {...props} />}
    />
    <Route
      path={Page.EDIT_TEMPLATE}
      exact
      component={(route_props) => <BreadcrumbsEditTemplate {...route_props} {...props} />}
    />

    <Route
      path={Page.FINE_GRAIN_ACCESS_POLICIES}
      exact
      component={(route_props) => <BreadcrumbsFgaPolicies {...route_props} {...props} />}
    />
    <Route
      path={Page.CREATE_FINE_GRAIN_ACCESS_POLICY}
      exact
      component={(route_props) => <BreadcrumbsCreateFgaPolicy {...route_props} {...props} />}
    />
    <Route
      path={Page.EDIT_FINE_GRAIN_ACCESS_POLICY}
      exact
      component={(route_props) => <BreadcrumbsEditFgaPolicy {...route_props} {...props} />}
    />
    <Route
      path={Page.VIEW_FINE_GRAIN_ACCESS_POLICY}
      exact
      component={(route_props) => <BreadcrumbsViewFgaPolicy {...route_props} {...props} />}
    />

    <Route
      path={Page.WORKSPACE_RESOURCE_LINKS}
      exact
      component={(route_props) => <BreadcrumbsWSResourceLinks {...route_props} {...props} />}
    />

    <Route
      path={Page.WORKSPACE_REDSHIFT_QUERY}
      exact
      component={(route_props) => <BreadcrumbsWSRedshiftQuery {...route_props} {...props} />}
    />

    <Route
      path={Page.INGESTION.REGISTER_CONTRACT}
      exact
      component={(route_props) => <BreadcrumbsRegisterContract {...route_props} {...props} />}
    />

    <Route
      path={Page.INGESTION.UPDATE_CONTRACT_V2}
      component={(route_props) => <BreadcrumbsUpdateContract {...route_props} {...props} />}
    />

    <Route
      path={Page.INGESTION.UPDATE_CONTRACT}
      component={(route_props) => <BreadcrumbsUpdateContract {...route_props} {...props} />}
    />

    <Route
      path={Page.INGESTION.DETAIL}
      component={(route_props) => <BreadcrumbsContractDetail {...route_props} {...props} />}
    />

    <Route
      path={Page.INGESTION.MONITORING}
      component={(route_props) => <BreadcrumbsMonitoringDataset {...route_props} {...props} />}
    />

    <Route
      path={Page.INGESTION.MONITORING_V2}
      component={(route_props) => <BreadcrumbsMonitoringDataset {...route_props} {...props} />}
    />

    <Route
      path={Page.WORKSPACE_DETAIL}
      exact
      render={(route_props) => <BreadcrumbsWSDetails {...route_props} {...props} />}
    />

    <Route
      path={Page.TAG_DETAIL}
      exact
      render={(route_props) => <BreadcrumbsWSTagDetails {...route_props} {...props} />}
    />

    <Route
      path={Page.METADATA_FORMS}
      exact
      component={(route_props) => <BreadcrumbsMetadataForms {...route_props} {...props} />}
    />
    <Route
      path={Page.CREATE_METADATA_FORM}
      exact
      component={(route_props) => <BreadcrumbsCreateMetadataForm {...route_props} {...props} />}
    />
    <Route
      path={Page.EDIT_METADATA_FORM}
      exact
      component={(route_props) => <BreadcrumbsEditMetadataForm {...route_props} {...props} />}
    />
    <Route
      path={Page.VIEW_METADATA_FORM}
      exact
      component={(route_props) => <BreadcrumbsViewMetadataForm {...route_props} {...props} />}
    />

    <Route
      path={Page.CLASSIFICATION}
      exact
      component={(route_props) => <BreadcrumbsClassification {...route_props} {...props} />}
    />
    <Route
      path={Page.BUSINESS_GLOSSARIES}
      exact
      component={(route_props) => <BreadcrumbsBusinessGlossaries {...route_props} {...props} />}
    />
    <Route
      path={Page.CREATE_BUSINESS_GLOSSARY}
      exact
      component={(route_props) => <BreadcrumbsCreateBusinessGlossary {...route_props} {...props} />}
    />
    <Route
      path={Page.EDIT_BUSINESS_GLOSSARY}
      exact
      component={(route_props) => <BreadcrumbsEditBusinessGlossary {...route_props} {...props} />}
    />
    <Route
      path={Page.VIEW_BUSINESS_GLOSSARY}
      exact
      component={(route_props) => <BreadcrumbsViewBusinessGlossary {...route_props} {...props} />}
    />
    <Route
      path={Page.GOVERNANCE_TAGS}
      exact
      component={(route_props) => <BreadcrumbsGovernanceTags {...route_props} {...props} />}
    />
    <Route
      path={Page.CREATE_GOVERNANCE_TAG}
      exact
      component={(route_props) => <BreadcrumbsCreateGovernanceTag {...route_props} {...props} />}
    />
    <Route
      path={Page.EDIT_GOVERNANCE_TAG}
      exact
      component={(route_props) => <BreadcrumbsEditGovernanceTag {...route_props} {...props} />}
    />
    <Route
      path={Page.VIEW_GOVERNANCE_TAG}
      exact
      component={(route_props) => <BreadcrumbsViewGovernanceTag {...route_props} {...props} />}
    />
    <Route path={Page.DATAZONE_MANAGE} exact component={BreadcrumbsDataZoneManage} />
    <Route path={Page.DATAZONE_ONBOARD} exact component={BreadcrumbsDataZoneOnboard} />
    <Route
      path={Page.LIST_REPORTS}
      exact
      component={(route_props) => <BreadcrumbsListReports {...route_props} {...props} />}
    />
    <Route
      path={Page.START_REPORT_GENERATION}
      exact
      component={(route_props) => <BreadcrumbsCreateReport {...route_props} {...props} />}
    />
    <Route
      path={Page.REPORT_DETAIL}
      exact
      component={(route_props) => <BreadcrumbsReportDetails {...route_props} {...props} />}
    />
    <Route
      path={Page.REQUEST_CONTEXT_DETAIL}
      exact
      component={(route_props) => <BreadcrumbsRequestContextDetails {...route_props} {...props} />}
    />
    <Route
      path={Page.SMUS_RESOURCES}
      exact
      component={(route_props) => <BreadcrumbsSmusResources {...route_props} {...props} />}
    />
    <Route
      path={Page.SMUS_SSO_GROUP_DETAIL}
      exact
      component={(route_props) => <BreadcrumbsSsoGroupDetails {...route_props} {...props} />}
    />
  </Switch>
);

export default Breadcrumbs;
